(function () {
class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}


class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    // eslint-disable-next-line class-methods-use-this
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
}


/* eslint-disable max-len */ const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: "Please enter a number.",
    patternMismatch: "Please match the requested format.",
    rangeOverflow: "Please select a value that is no more than {max}.",
    rangeUnderflow: "Please select a value that is no less than {min}.",
    stepMismatch: "Please select a value that is a multiple from {step}.",
    tooLong: "Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.",
    tooShort: "Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.",
    typeMismatch: "The value you have entered for this field is invalid.",
    valueMissing: "Please fill out this field.",
    // These properties must be empty.
    valid: "",
    customError: ""
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: "The password does not match the one above."
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: "The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}",
    existigName: "This name {currentValue} already exists."
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: "1-6-6220",
        text: "Shopping cart is empty"
    },
    messageAddedToBasket: {
        code: "1-6-6221",
        text: "added to the shopping cart"
    },
    quickOrderMessageTooShort: {
        code: "1-6-6222",
        text: "At least %1 characters are required for a search."
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: "1-6-6226",
        text: "Delivery method changed"
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: "1-6-6227",
        text: "Payment type credit card"
    },
    messagePaymentTypeInvoice: {
        code: "1-6-6227",
        text: "Payment type invoice"
    },
    messagePaymentTypeInAdvance: {
        code: "1-6-6227",
        text: "Payment type advance payment"
    },
    messagePaymentTypeOnDelivery: {
        code: "1-6-6227",
        text: "Payment type cash on delivery"
    },
    messagePaymentTypeGeneral: {
        code: "1-6-6227",
        text: "Payment type changed"
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: "1-6-6240",
        text: ""
    },
    allRemoved: {
        code: "1-6-6240",
        text: "All items removed"
    },
    empty: {
        code: "1-6-6240",
        text: "Your article comparison is empty."
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: "2-6-6270",
        text: "Unable to create the wish list; the name is invalid."
    },
    messageMaxLists: {
        code: "2-6-6277",
        text: "Max. number of wish lists reached!"
    },
    messageMaxPositions: {
        code: "2-6-6278",
        text: "Max. number of positions reached!"
    },
    messageDeleteConfirmation: {
        code: "2-6-6273",
        text: "Do you really want to delete the wish list?"
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: "1-6-6290",
        text: "No match found!"
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: "1-6-6200",
        text: "Do you really want to delete this address?"
    },
    messageChangeSuccess: {
        code: "1-6-6200",
        text: "Address successfully modified."
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: "1-6-6290",
        text: "The output was suppressed due to an empty text."
    },
    messageOk: {
        code: "1-6-6290",
        text: "Yes"
    },
    messageCancel: {
        code: "1-6-6290",
        text: "No"
    },
    messageChange: {
        code: "1-6-6290",
        text: "The selection was changed"
    },
    messageDefault: {
        code: "1-6-0000",
        text: ""
    },
    messageDefaultInfo: {
        code: "1-6-0000",
        text: ""
    },
    messageDefaultWarning: {
        code: "2-6-0000",
        text: ""
    },
    messageDefaultError: {
        code: "3-6-0000",
        text: ""
    },
    messageDefaultDebug: {
        code: "4-6-0000",
        text: ""
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: "1-6-6260",
        text: "At least 3 characters!"
    },
    messageResultEmpty: {
        code: "1-6-6260",
        text: "No items found!"
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: "1-6-2002",
        text: "Store the files here to upload them"
    },
    fallbackMessage: {
        code: "2-6-2002",
        text: "Your browser does not support drag&drop file uploads"
    },
    fallbackText: {
        code: "2-6-2002",
        text: "Use the form to upload your files"
    },
    fileTooBig: {
        code: "2-6-2002",
        text: "The file is too large. The maximum file size is {{maxFileSize}} MB"
    },
    invalidFileType: {
        code: "2-6-2002",
        text: "Unable to upload files of this type"
    },
    responseError: {
        code: "3-6-2002",
        text: "The server rejected your request with status {{statusCode}}"
    },
    cancelUpload: {
        code: "1-6-2002",
        text: "Cancel upload"
    },
    cancelUploadConfirmation: {
        code: "1-6-2002",
        text: "Cancel upload?"
    },
    removeFile: {
        code: "1-6-2002",
        text: "Remove file"
    },
    maxFilesExceeded: {
        code: "2-6-2002",
        text: "You are not allowed to upload any more files"
    },
    buttonBrowse: {
        code: "1-6-2002",
        text: "Select files to upload"
    },
    uploadHint: {
        code: "1-6-2002",
        text: "Drag files and folders here"
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: "1-1-6280",
        text: "Keine Ergebnisse gefunden."
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: "3-6-6230",
        text: "Please accept the General terms and conditions."
    },
    loadingCheckoutTitle: {
        code: "1-6-6260",
        text: "Almost done!"
    },
    loadingCheckoutText: {
        code: "1-6-6261",
        text: "The order is carried out. This can take a moment!"
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: "3-6-6000",
        text: "Something has gone wrong!"
    },
    htmlError401: {
        code: "3-6-6000",
        text: "A valid authentication is required to process the request."
    },
    htmlError403: {
        code: "3-6-6000",
        text: "The request could not be processed due to missing authorization of the client."
    },
    htmlError404: {
        code: "3-6-6000",
        text: "The requested site does not exist."
    },
    htmlError413: {
        code: "3-6-6000",
        text: "The file is too large."
    },
    htmlError415: {
        code: "3-6-6000",
        text: "This media type is not supported."
    },
    htmlError422: {
        code: "3-6-6000",
        text: "Unable to display the requested site correctly."
    },
    htmlError500: {
        code: "3-6-6000",
        text: "Internal server error"
    },
    htmlError503: {
        code: "3-6-6000",
        text: "The server is temporarily unavailable."
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false)=>{
    if (!html) $2d540709c75492d4$var$render("<div></div>");
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
})($1221feb2184dfefe$export$9130146a86a85749 || ($1221feb2184dfefe$export$9130146a86a85749 = {}));
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return "";
    if (response.pluginId === "paymentType") {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === "deliveryType") textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === "checkoutAdressChange") textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = "white")=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        "display: block"
    ].join(";");
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            // eslint-disable-next-line no-console
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("green"));
        },
        ["Warning"] () {
            // eslint-disable-next-line no-console
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("yellow", "black"));
        },
        ["Error"] () {
            // eslint-disable-next-line no-console
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("red"));
        },
        ["Info"] () {
            // eslint-disable-next-line no-console
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle("blue"));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector("[data-tk-message-container]");
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement("beforeend", messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll("dialog[open]");
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add("tk-message--show");
    messageContainer.appendChild(toast);
    toast.addEventListener("animationend", (event)=>{
        if (event.animationName !== "fadeout") return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $4576c900b5c49dcd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute("data-tk-event-name") || "event-purchase";
        this.basketId = this.querySelector("[data-tk-otm-basket-id]") || undefined;
        this.messageContainerSelector = this.getAttribute("data-tk-message-container-selector") || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector("[data-tk-session-timeout-wrapper]") || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute("data-tk-session-time") || 0);
        this.firstItemToScrollInto = this.querySelector("[data-tk-scroll-into]") || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll(".Info");
        const errorMessage = messageContainer.querySelectorAll(".Error");
        const warningMessage = messageContainer.querySelectorAll(".Warning");
        const debugMessage = messageContainer.querySelectorAll(".Debug");
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || "";
            const code = item.querySelector(".was-message-code")?.textContent || "";
            const addition = item.querySelector(".was-message-addition")?.textContent || "";
            const wait = Number(item.querySelector(".was-message-wait")?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: "event-purchase",
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector("[data-tk-otm-affiliation]");
        const revenue = this.querySelector("[data-tk-otm-revenue]");
        const tax = this.querySelector("[data-tk-otm-tax]");
        const shipping = this.querySelector("[data-tk-otm-shipping]");
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : "",
            revenue: revenue ? revenue.innerText : "",
            tax: tax ? tax.innerText : "",
            shipping: shipping ? shipping.innerText : ""
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll("[data-tk-otm-item]");
        Array.from(items).forEach((item)=>{
            const id = item.querySelector(".otm-id");
            const name = item.querySelector(".otm-name");
            const brand = item.querySelector(".otm-brand");
            const category = item.querySelector(".otm-category");
            const price = item.querySelector(".otm-price");
            const quantity = item.querySelector(".otm-quantity");
            const position = item.querySelector(".otm-position");
            data.push({
                id: id ? id.innerText : "",
                name: name ? name.innerText : "",
                brand: brand ? brand.innerText : "",
                category: category ? category.innerText : "",
                price: price ? price.innerText : "",
                quantity: quantity ? quantity.innerText : "",
                position: position ? position.innerText : ""
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute("data-tk-scroll-into-offset")) || 16;
        const mainContainer = this.querySelector("main");
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: "smooth"
            });
        }, 0);
    }
}



var $9a3403e3213d867d$var$HoverState;
(function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
})($9a3403e3213d867d$var$HoverState || ($9a3403e3213d867d$var$HoverState = {}));
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector("input, select, textarea");
        this.labelElement = this.querySelector("label") || undefined;
        this.isMaterial = this.hasAttribute("data-tk-is-material");
        this.materialClass = this.getAttribute("data-tk-material-class") || "tk-form-material";
        this.materialNumberInputClass = this.getAttribute("data-tk-material-number-input-class") || "tk-form-material--number";
        this.materialLabelInsideClass = this.getAttribute("data-tk-material-label-inside-class") || "tk-form-material--label-inside";
        this.materialSelectFocussedClass = this.getAttribute("data-tk-material-select-focussed-class") || "tk-form-select--focussed";
        this.materialLoadedClass = this.getAttribute("data-tk-material-loaded-class") || "tk-form-material--loaded";
        this.isPasswordInput = this.hasAttribute("data-tk-toggle-password");
        this.disableOnAddonClick = this.hasAttribute("data-tk-disable-on-addon-click");
        this.addonElement = this.querySelector("[data-tk-addon]") || undefined;
        this.waitForSurroundingContent = this.closest("[data-wait-for-surrounding-content]") || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute("data-tk-addon-default-padding") || "0", 10) || 4;
        this.onTransitionEnd = ()=>{};
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener("DOMContentLoaded", ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute("required")) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                "disabled"
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute("disabled");
        this.classList.toggle("tk-form-input--disabled", addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: "click",
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: "mouseenter",
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: "mouseleave",
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error("No Input element found");
        this.classList.toggle("tk-form--addon-hover", hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error("No Input element found");
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === "number";
        if (isNumberInput) this.fieldElement.setAttribute("type", "text");
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute("type", "number");
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: "mousedown",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "mouseup",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "touchstart",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: "touchend",
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error("Missing input element");
        if (event.type === "mousedown" || event.type === "touchstart") this.fieldElement.type = "text";
        else this.fieldElement.type = "password";
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error("No element found");
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error("Missing addon");
        const addonType = this.addonElement.getAttribute("data-tk-addon");
        if (addonType !== "prefix" && addonType !== "suffix") throw new Error("Wrong addon type");
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector("option:checked");
            const isPlaceholderOption = selectedOption?.hasAttribute("data-tk-empty-option");
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === "";
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error("Missing label element");
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error("Missing label element");
            this.labelElement.removeAttribute("style");
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : "0px";
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : "0px";
        this.labelElement.style.paddingInline = "0";
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = "0";
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === "suffix" ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === "prefix") this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === "suffix") this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === "number";
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: "input",
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: "focusin",
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: "focusout",
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === "focusin") this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error("Missing label element");
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: "transitionend",
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener("transitionend", this.onTransitionEnd);
    }
}



class $59575c6d2ba9e740$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.accordionHead = this.querySelector("[data-tk-accordion-head]") || undefined;
        this.accordionBody = this.querySelector("[data-tk-accordion-body]") || undefined;
        this.accordionIcon = this.querySelector("[data-tk-accordion-icon]") || undefined;
        this.accordionIcons = {
            iconAdd: this.getAttribute("data-tk-icon-open") || "tk-icon-add",
            iconRemove: this.getAttribute("data-tk-icon-collapse") || "tk-icon-remove"
        };
        this.isActive = this.hasAttribute("data-tk-accordion-is-active");
        this.isHeaderLink = this.accordionHead && this.accordionHead.hasAttribute("data-tk-accordion-link");
        this.activeClassName = this.getAttribute("data-tk-active-class-name") || "tk-tabs-accordion--active";
    }
    connectedCallback() {
        if ((!this.accordionHead || !this.accordionBody || !this.accordionIcon) && !this.isHeaderLink) throw new Error("Accordion: Elements are missing!");
        this.setAccordionState(this.isActive);
        this.registerListener();
    }
    registerListener() {
        const eventHandler = this.toggleEvent.bind(this);
        this.pushListener({
            event: "click",
            element: this.accordionHead,
            action: eventHandler
        });
    }
    toggleEvent() {
        this.toggleMarkupElements();
    }
    toggleMarkupElements() {
        this.classList.toggle(this.activeClassName);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconAdd);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconRemove);
    }
    setAccordionState(isActive) {
        if (isActive) {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
        } else this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6;
(function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
})($fe64c06a372e274b$export$bcd15065bd7fecf6 || ($fe64c06a372e274b$export$bcd15065bd7fecf6 = {}));
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split(".").reverse().join("-");
    const dateFormattedB = b.split(".").reverse().join("-");
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(":").map((item)=>Number(item));
    const splittedB = b.split(":").map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(" ");
    const timeStampListB = b.split(" ");
    const dateA = timeStampListA.at(0)?.split(".").reverse().join("-");
    const dateB = timeStampListB.at(0)?.split(".").reverse().join("-");
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = "/WebPortal/async.aspx";
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = window.atob(response.data);
    const html = document.createElement("div");
    html.innerHTML = data;
    const json = response.contentType === "application/json" && html.innerText !== "" ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === "ok",
        dataAsHtml: response.contentType === "text/html" ? html.innerText : "",
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || "");
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$24835cb787452b46 = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = "default", showMessages: showMessages = true })=>{
    const headers = new Headers({
        "x-requested-with": "XMLHttpRequest",
        "response-type": "json"
    });
    let body;
    if (payload) {
        headers.set("content-type", "application/x-www-form-urlencoded; charset=UTF-8");
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? "POST" : "GET",
        headers: headers,
        cache: cache,
        credentials: "include",
        body: body
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get("content-type");
        const data = contentType?.includes("application/json") ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        rejectHandler(error);
    }
};


var $2595e2ca594d6789$var$DataMaster;
(function(DataMaster) {
    DataMaster["CLIENT"] = "client";
})($2595e2ca594d6789$var$DataMaster || ($2595e2ca594d6789$var$DataMaster = {}));
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.gridTemplateColList = [];
        this.isHorizontalScrollable = false;
        this.headElement = this.querySelector("[data-tk-table-head]") || undefined;
        if (!this.headElement) throw new Error("Table: Head is missing!");
        this.rowHeadElement = this.headElement.querySelector("[data-tk-table-row]") || undefined;
        this.headShadowClassName = this.getAttribute("data-tk-head-shadow-class-name") || "tk-table__head-shadow";
        this.isStickyLeft = this.hasAttribute("data-tk-is-sticky-left");
        this.isStickyHead = this.hasAttribute("data-tk-is-sticky-head");
        this.gridTemplateMobile = this.getAttribute("data-tk-grid-template-mobile") || "1fr";
        this.loadedClassName = this.getAttribute("data-tk-loaded-class-name") || "tk-table--loaded";
        this.stickyLeftClassname = this.getAttribute("data-tk-sticky-left-class-name") || "tk-table--sticky-left";
        this.rightShadowClassName = this.getAttribute("data-tk-right-shadow-class-name") || "tk-table__right-shadow";
        this.stickyHeadClassName = this.getAttribute("data-tk-sticky-head-class-name") || "tk-table--sticky-head";
        this.customCols = this.getAttribute("data-tk-col-width") || "auto";
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute("data-tk-desktop-min-width")) || 992;
        this.rowLinkSelector = "data-tk-table-row-link";
        this.table = this.querySelector("table") || undefined;
        this.ascSortClassName = this.getAttribute("data-tk-asc-sort-class-name") || "tk-table--sort-asc";
        this.descSortClassName = this.getAttribute("data-tk-desc-sort-class-name") || "tk-table--sort-desc";
        this.isSortTable = Boolean(this.table?.hasAttribute("data-tk-table-sort"));
        this.colAlignStart = this.hasAttribute("data-tk-col-align-start");
        this.colAlignStartClassName = this.getAttribute("data-tk-col-align-start-class-name") || "tk-table__col--align-left";
        this.colItemAlignCenter = this.hasAttribute("data-tk-col-item-align-center");
        this.colItemAlignCenterClassName = this.getAttribute("data-tk-col-item-align-center-class-name") || "tk-table__col--item-align-center";
        this.colItemAlignStart = this.hasAttribute("data-tk-col-item-align-start");
        this.colItemAlignStartClassName = this.getAttribute("data-tk-col-item-align-start-class-name") || "tk-table__col--item-align-start";
        this.colItemAlignEnd = this.hasAttribute("data-tk-col-item-align-end");
        this.colItemAlignEndClassName = this.getAttribute("data-tk-col-item-align-end-class-name") || "tk-table__col--item-align-end";
        this.tableSelector = "[data-tk-table-sort]";
        this.sortDirectionSelector = "[data-tk-sort-direction]";
        this.tkSortDirectionSelector = "tkSortDirection";
        this.tkSortAttrSelector = "tkSortAttr";
        this.tkSortDatatypeSelector = "tkSortDatatype";
        this.dataMasterSelector = "data-tk-datamaster";
        this.dataSortAttrSelector = "data-tk-sort-attr";
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: "tk-viewport-resize",
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const handleHorizontalScrollListener = this.toggleScrollHorizontalBehavior.bind(this);
        this.pushListener({
            event: "scroll",
            element: this,
            action: handleHorizontalScrollListener
        });
        if (this.isStickyLeft) {
            const handleStickyLeftListener = this.toggleScrollLeftBehavior.bind(this);
            this.pushListener({
                event: "scroll",
                element: this,
                action: handleStickyLeftListener
            });
        }
        if (this.isStickyHead) {
            const handleStickyHeadListener = this.toggleScrollTopBehavior.bind(this);
            this.pushListener({
                event: "scroll",
                element: this,
                action: handleStickyHeadListener
            });
        }
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: "click",
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: "click",
            element: this,
            action: handleRowLink
        });
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest("a")) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest("th");
        column && column.hasAttribute("data-tk-sort-direction") && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(",") ? this.gridTemplateColList?.join(" ") : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove("tk-table__head--force-mobile");
        const titleElements = this.table?.querySelectorAll("[data-tk-table-body] .tk-table__title");
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove("tk-table__title--force-mobile");
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add("tk-table__head--force-mobile");
        const titleElements = this.table?.querySelectorAll("[data-tk-table-body] .tk-table__title");
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add("tk-table__title--force-mobile");
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = element.scrollTop.toFixed();
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement("afterbegin", this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement("beforeend", this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll("[data-tk-table-row]");
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll("[data-tk-table-value]")).at(headItem.column)?.textContent || "";
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = "";
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: "tablesort",
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr !== sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = "";
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll("[data-tk-table-row] td");
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector("[data-tk-table-body]");
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll("[data-tk-table-row] td");
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
}



class $0d07f57cc5d15afe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    // eslint-disable-next-line no-useless-constructor
    constructor(){
        super();
        this.selectorFlagItem = "[data-tk-flag-item]";
        this.selectorFlagIcon = "[data-tk-flag-icon]";
        this.selectorFlagLabel = "[data-tk-flag-label]";
        this.flagItems = [];
        this.removedFlagElements = [];
    }
    connectedCallback() {
        this.getAllFlags();
        if (this.flagItems.length < 1) return;
        this.appendSummarizedFlag();
    }
    getAllFlags() {
        const allFlagElements = this.querySelectorAll(this.selectorFlagItem) || undefined;
        // convert NodeList to Array
        const allFlags = Array.from(allFlagElements);
        // remove last Element (not needed for Tooltip-Flag)
        allFlags.pop();
        if (allFlags.length < 1) return;
        allFlags.forEach((item)=>{
            const iconElem = item.querySelector(this.selectorFlagIcon);
            const labelElem = item.querySelector(this.selectorFlagLabel);
            const singleFlagItem = {
                icon: iconElem?.outerHTML,
                label: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === "true" ? labelElem.innerHTML : "",
                showIcon: iconElem?.getAttribute(this.selectorFlagIcon.slice(1, -1)) === "true",
                showLabel: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === "true"
            };
            this.flagItems.push(singleFlagItem);
            this.removedFlagElements.push(item);
            item.remove();
        });
    }
    getFlagDetails() {
        const returnVal = [];
        this.flagItems.forEach((elem)=>{
            let tooltipString;
            if (elem.showLabel) tooltipString = elem.showIcon ? `${elem.icon} ${elem.label}` : `${elem.label}`;
            else {
                const removedElement = this.removedFlagElements.shift();
                const removedElementLabel = removedElement?.querySelector("[data-tk-flag-label]")?.innerHTML;
                const tmpTooltipString = removedElementLabel || "";
                tooltipString = elem.showIcon ? `${elem.icon}` : tmpTooltipString;
            }
            returnVal.push(tooltipString);
        });
        return returnVal.join(", ").trim();
    }
    appendSummarizedFlag() {
        const tooltipTemplate = this.querySelector("[data-tk-flag-merged]");
        if (!tooltipTemplate) return;
        const clone = tooltipTemplate.content.cloneNode(true);
        const tooltipElement = clone.querySelector("[data-tk-tooltip-content]");
        if (!tooltipElement) return;
        tooltipElement.innerHTML = `+${this.flagItems.length}`;
        tooltipElement.setAttribute("data-tk-tooltip-content", this.getFlagDetails());
        this.prepend(clone);
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}


function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = "top";
var $935c50c8659545b7$export$40e543e69a8b3fbb = "bottom";
var $935c50c8659545b7$export$79ffe56a765070d2 = "right";
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = "left";
var $935c50c8659545b7$export$dfb5619354ba860 = "auto";
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = "start";
var $935c50c8659545b7$export$bd5df0f255a350f8 = "end";
var $935c50c8659545b7$export$390fd549c5303b4d = "clippingParents";
var $935c50c8659545b7$export$d7b7311ec04a3e8f = "viewport";
var $935c50c8659545b7$export$ae5ab1c730825774 = "popper";
var $935c50c8659545b7$export$ca50aac9f3ba507f = "reference";
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = "beforeRead";
var $935c50c8659545b7$export$aafa59e2e03f2942 = "read";
var $935c50c8659545b7$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = "beforeMain";
var $935c50c8659545b7$export$f22da7240b7add18 = "main";
var $935c50c8659545b7$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = "beforeWrite";
var $935c50c8659545b7$export$68d8715fc104d294 = "write";
var $935c50c8659545b7$export$70a6e5159acce2e6 = "afterWrite";
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: "end",
    end: "start"
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement("div");
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, "NodeList");
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, "MouseEvent");
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($c55de979aca75bc6$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.selectorTooltipContent = "data-tk-tooltip-content";
        this.selectorTooltipOptions = "data-tk-tooltip-options";
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || "{}";
        if (!this.tooltipContent) throw new Error("TK: Missing tooltip content");
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        // @ts-ignore
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    // eslint-disable-next-line class-methods-use-this
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: "tk-tooltip",
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}



class $2e3d1137f4724c0f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute("data-tk-resize-event-name") || "tk-viewport-resize";
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                "xs",
                576
            ],
            [
                "s",
                768
            ],
            [
                "m",
                992
            ],
            [
                "l",
                1200
            ],
            [
                "xl",
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = "xs";
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}







var $fd4fdaa8be3050bd$export$eb1b84084436143e;
(function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
})($fd4fdaa8be3050bd$export$eb1b84084436143e || ($fd4fdaa8be3050bd$export$eb1b84084436143e = {}));
class $fd4fdaa8be3050bd$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector("[data-tk-basket-list]") || undefined;
        this.totalAmount = document.querySelector("[data-tk-basket-total-amount]") || undefined;
        this.miniBasket = document.querySelector("tk-minibasket") || undefined;
        this.emptyClassName = this.basketList?.getAttribute("data-tk-basket-empty-class-name") || "module-basket--empty";
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: "basket",
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith("tkSaldocitem.")).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === "addall") {
            const quantities = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== "{}" && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector("[data-tk-basket-add-all-wrapper]");
        const articles = articleList?.querySelectorAll("article");
        articles?.forEach((article)=>{
            const id = article.getAttribute("data-tk-item-number");
            if (!id) return;
            const basketButton = article.querySelector("tk-basket-button");
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll("[data-tk-dimension]:not([hidden])");
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute("data-tk-dimension") || "";
                const fieldElement = dimension.querySelector("[data-tk-input-quantity]");
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || "0";
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = "";
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector("[data-tk-input-quantity]");
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = "";
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector("[data-tk-basket-dim-unit]");
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === "added") (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute("data-count", `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === "delete" || tkAction === "deleteall") {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest("[data-tk-basket-item]");
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === "change") {
            // update item price and amount
            const price = this.component.closest("[data-tk-basket-item]")?.querySelector("[data-tk-basket-item-price]");
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest("[data-tk-basket-item]")?.querySelector("[data-tk-basket-item-amount]");
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest("tk-quick-order")) {
            // update after quickorder
            const quickorder = this.component.closest("tk-quick-order");
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector("[data-tk-basket-total-vat]");
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector("[data-tk-basket-list]");
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector("[data-tk-basket-list-actions] > tk-basket-button");
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector("[data-tk-basket-list-actions]");
            const deleteAllButton = html.querySelector("[data-tk-basket-list-actions] > tk-basket-button");
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement("beforeend", deleteAllButton);
        }
        const footer = document.querySelector("[data-tk-basket-list-footer]");
        if (!footer) {
            const footerWrapper = html.querySelector("[data-tk-basket-list-footer]");
            footerWrapper && this.basketList.insertAdjacentElement("afterend", footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest("[data-tk-counter]");
        if (!wrapper) wrapper = target.closest("[data-tk-dimension]");
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector("[data-tk-counter-decreaser]");
        const incrementButton = wrapper.querySelector("[data-tk-counter-increaser]");
        const inputField = wrapper.querySelector("[data-tk-input-quantity]");
        if (!inputField) return;
        const step = Number(inputField.getAttribute("step") || 1);
        const min = Number(inputField.getAttribute("min") || step);
        const max = Number(inputField.getAttribute("max") || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = false;
        let operator = "+";
        if (incrementButton && target === incrementButton) {
            operator = "+";
            if (oldValue < min) operator = "-";
        } else if (decrementButton && target === decrementButton) {
            operator = "-";
            if (oldValue > max && isMaxSet) operator = "+";
        }
        if (event.key === "ENTER") {
            if (oldValue > max) operator = "+";
            else if (oldValue < min) operator = "-";
        }
        if (artDimCheck > 0) {
            const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace("{currentValue}", String(oldValue)).replace("{newValue}", String(result)).replace("{step}", String(step)));
                operator = "+";
            }
        }
        if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || "");
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || "");
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || "");
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || "");
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || "");
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || "");
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = "+") {
        const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = currentVal * 10 ** multiplikator;
        const stepPow = step * 10 ** multiplikator;
        const minPow = min * 10 ** multiplikator;
        const maxPow = max * 10 ** multiplikator;
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            "-": ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcMinus(currentVal, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            "+": ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcPlus(currentVal, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace("{step}", String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace("{max}", String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow < minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace("{min}", String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    }
}




var $127c03b03da38c7a$export$416096e8140b15df;
(function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
})($127c03b03da38c7a$export$416096e8140b15df || ($127c03b03da38c7a$export$416096e8140b15df = {}));
class $127c03b03da38c7a$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute("data-tk-action") || "add";
        this.button = this.querySelector("[data-tk-basket-button]") || undefined;
        this.counterWrapper = this.querySelector("[data-tk-counter]") || undefined;
        this.variantWrapper = this.querySelector("[data-tk-basket-variants]") || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector("[data-tk-counter-decreaser]") || undefined;
            this.increaser = this.querySelector("[data-tk-counter-increaser]") || undefined;
            this.counter = this.querySelector("[data-tk-input-quantity]") || undefined;
            this.counters = this.querySelectorAll("[data-tk-input-quantity]");
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error("Basket: Button is missing!");
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: "click",
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: "change",
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: "click",
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: "click",
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: "change",
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: "click",
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: "click",
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                "refreshed-list": ()=>event.data && this.closeDialog(event.data),
                "refreshed-basket": ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest("dialog");
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
        }, 500);
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute("data-tk-art-dim-check-cd") === "1";
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace("{currentValue}", String(currentValue)).replace("{newValue}", String(result)).replace("{step}", String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || "0";
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || "";
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || "";
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute("data-tk-min"));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute("data-tk-max"));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute("data-tk-step"));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute("data-tk-art-dim-check-cd") || "";
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector("[data-tk-input-quantity]");
            const nameElement = wrapper.querySelector("[data-tk-basket-dim-unit-name]");
            const unitElements = wrapper.querySelectorAll("[data-tk-basket-dim-unit]");
            if (!fieldElement) return;
            fieldElement.value = value !== "0" ? value : "";
            fieldElement.setAttribute("data-tk-art-dim-check-cd", getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute("min", String(getDimensionMin()));
            else fieldElement.removeAttribute("min");
            if (getDimensionMax() > 0) fieldElement.setAttribute("max", String(getDimensionMax()));
            else fieldElement.removeAttribute("max");
            if (getDimensionStep() > 0) fieldElement.setAttribute("step", String(getDimensionStep()));
            else fieldElement.removeAttribute("step");
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll("[data-tk-dimension]:not([hidden])");
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute("data-tk-dimension");
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute("data-tk-variant", selectedVariant.value);
    }
}



function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $d9484b764f1a944d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll("[data-tk-context-button]");
        this.items = this.querySelector("[data-tk-context-items]") || undefined;
        this.openClassName = this.getAttribute("data-tk-open-class-name") || "tk-context-menu--open";
        this.responsiveClassName = this.getAttribute("data-tk-responsive-class-name") || "tk-context-menu--responsive";
        this.dropDownClassName = this.getAttribute("data-tk-dropdown-class-name") || "tk-context-menu__dropdown";
        this.showAlways = this.hasAttribute("data-tk-show-always");
        this.disableScrolldownBreakpoint = this.getAttribute("data-tk-disable-scrolldown-breakpoint") || "s";
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute("data-tk-context-offset")) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error("Context Menu: Elements are missing!");
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: "click",
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: "click",
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: "tk-viewport-resize",
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton() {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton();
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton();
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement("beforeend", copiedItems);
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    setPosition(element) {
        const button = this.getVisibleButton();
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    close(event) {
        const button = this.getVisibleButton();
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.copiedItems.classList.remove(this.openClassName);
            this.removeListener(window);
            this.resizeObserver.unobserve(document.body);
        }
    }
}





var $2215c02a950e9fbf$var$DialogActions;
/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ (function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
})($2215c02a950e9fbf$var$DialogActions || ($2215c02a950e9fbf$var$DialogActions = {}));
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dialogs = [];
        this.currentDialog = 0;
        this.shouldOpen = false;
        this.closeOnBackdropClick = true;
        this.url = this.getAttribute("data-tk-url") || undefined;
        this.button = this.querySelector("button") || undefined;
        this.shouldOpen = this.hasAttribute("data-tk-open");
        this.closeOnBackdropClick = this.hasAttribute("data-tk-close-on-backdrop-click") ? JSON.parse(this.getAttribute("data-tk-close-on-backdrop-click")) : true;
        this.shouldMaxWidth = this.hasAttribute("data-tk-should-max-width");
        this.dialogClassName = this.getAttribute("data-tk-dialog-class-name") || "tk-dialog";
        this.dialogInnerClassName = this.getAttribute("data-tk-dialog-inner-class-name") || "tk-dialog__inner";
        this.dialogCloseClassName = this.getAttribute("data-tk-dialog-close-class-name") || "tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close";
        this.maxWidthClassName = this.getAttribute("data-tk-max-width-class-name") || "tk-dialog--max-width";
        this.formDataString = this.getAttribute("data-tk-form-data") || undefined;
        this.isPopup = this.hasAttribute("data-tk-is-popup");
        this.isConfirm = this.hasAttribute("data-tk-is-confirm");
        this.confirmTitle = this.getAttribute("data-tk-confirm-title") || undefined;
        this.confirmDescription = this.getAttribute("data-tk-confirm-description") || undefined;
        this.confirmCancelIcon = this.getAttribute("data-tk-confirm-cancel-icon") || "cross";
        this.confirmCancelLabel = this.getAttribute("data-tk-confirm-cancel-label") || undefined;
        this.confirmSubmitIcon = this.getAttribute("data-tk-confirm-submit-icon") || "check";
        this.confirmSubmitLabel = this.getAttribute("data-tk-confirm-submit-label") || undefined;
        this.forceReloadContent = this.hasAttribute("data-tk-force-reload-content");
    }
    connectedCallback() {
        if (!this.url) throw new Error("Dialog: URL is missing!");
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: "click",
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: "submit",
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: "click",
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ""}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: "dialog",
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: "close",
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            this.isPopup ? dialog.show() : dialog.showModal();
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector("[data-tk-dialog-content]");
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        this.isPopup ? dialog.show() : dialog.showModal();
        this.hookAfterShowModal(dialog);
        const form = content.querySelector("form");
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>dialog.close());
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close-and-reset]", (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-forward]", (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-backward]", (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-jump-to]", (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener("click", ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        dialogItem.dialog.close();
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            const waitForContent = this.forceReloadContent;
            if (this.forceReloadContent) this.renewDialogContent(nextDialog, url);
            if (waitForContent) return;
            nextDialog.showModal();
        } else try {
            const payload = JSON.parse(this.formDataString || "{}");
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute("data-tk-url");
        if (!url) throw new Error("Dialog: URL is missing!");
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        nextDialogItem.dialog.showModal();
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute("data-tk-dialog-jump-to"));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        nextDialogItem.dialog.showModal();
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute("data-tk-switch-to-next");
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = "tk-dialog", closeClassName: closeClassName = "tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close", innerClassName: innerClassName = "tk-dialog__inner", content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement("beforeend", dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, "[data-tk-dialog-close]", ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add("tk-dialog--open");
    }
    static close(element) {
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove("tk-dialog--open");
            element.dispatchEvent(new Event("close"));
        }
    }
    static closeDialogIfOutside(element, event) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) element.close();
    }
    checkAutoOpen() {
        if (this.shouldOpen) this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector("[data-tk-dialog-content]");
        dialogInner.innerHTML = response.dataAsHtml;
        openDialog.showModal();
        this.hookAfterShowModal(openDialog);
    }
}



class $4646e54a00c9195e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.itemsCounterElement = this.querySelector("[data-compare-items-count]") || undefined;
    }
    connectedCallback() {
        this.registerAttributeChangeListener();
        this.onItemsCountChanged();
    }
    registerAttributeChangeListener() {
        if (!this.itemsCounterElement) throw new Error("Missing items count element");
        // Konfiguration des Observers
        const config = {
            attributes: true,
            attributeFilter: [
                "data-compare-items-count"
            ]
        };
        // Erstellung des Mutation Observers mit der Ziel-Element und der Konfiguration
        const observer = new MutationObserver(this.onItemsCountChanged.bind(this));
        // Beginnen des Beobachtens des Ziel-Elements
        observer.observe(this.itemsCounterElement, config);
    }
    onItemsCountChanged() {
        const currentItemsCountString = this.itemsCounterElement?.getAttribute("data-compare-items-count");
        const currentItemsCount = parseInt(currentItemsCountString || "0", 10);
        const headerElement = this.querySelector("[data-tk-compare-header]");
        if (!headerElement) return;
        if (currentItemsCount === 0) headerElement.classList.add("tk-compare__header--empty");
        else headerElement.classList.remove("tk-compare__header--empty");
    }
}



class $ff73fd6b4831733d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.desktopMinWidth = Number(this.getAttribute("data-tk-desktop-min-width")) || 1200;
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.compareCategoryDefaultWrapper = this.querySelector("[data-tk-category-default-wrapper]") || undefined;
        this.compareCategoryWrapper = this.querySelector("[data-tk-category-wrapper]") || undefined;
        this.compareCategorySelect = this.querySelector("[data-tk-categories]") || undefined;
        this.compareRowContainer = this.querySelector("[data-tk-row-container]") || undefined;
        this.compareItemsCount = Number(this.getAttribute("data-compare-items-count")) || 0;
    }
    connectedCallback() {
        this.registerViewportListener();
        this.isMobile && this.switchToMobile();
        this.observeItemsCount();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: "tk-viewport-resize",
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    switchToMobile() {
        if (this.isMobileActive || this.compareItemsCount <= 0) return;
        this.isMobileActive = true;
        // place category select in category compare wrapper
        if (!this.compareCategoryWrapper) throw new Error("Missing compare category wrapper element");
        if (!this.compareCategorySelect) throw new Error("Missing compare category select element");
        this.compareCategorySelect.parentElement?.removeChild(this.compareCategorySelect);
        this.compareCategoryWrapper.appendChild(this.compareCategorySelect);
        // hide first column
        if (!this.compareRowContainer) throw new Error("Missing rows container");
        const rows = this.compareRowContainer.querySelectorAll("[data-tk-row]");
        rows.forEach((row)=>{
            const firstDiv = row.querySelector("div:first-of-type");
            if (firstDiv) firstDiv.setAttribute("hidden", "");
        });
    }
    switchToDesktop() {
        if (!this.isMobileActive || this.compareItemsCount <= 0) return;
        this.isMobileActive = false;
        // place category select in category compare default wrapper
        if (!this.compareCategoryDefaultWrapper) throw new Error("Missing compare category default wrapper element");
        if (!this.compareCategorySelect) throw new Error("Missing compare category select element");
        this.compareCategorySelect.parentElement?.removeChild(this.compareCategorySelect);
        this.compareCategoryDefaultWrapper.appendChild(this.compareCategorySelect);
        // show first column
        if (!this.compareRowContainer) throw new Error("Missing rows container");
        const rows = this.compareRowContainer.querySelectorAll("[data-tk-row]");
        rows.forEach((row)=>{
            const firstDiv = row.querySelector("div:first-of-type");
            if (firstDiv) firstDiv.removeAttribute("hidden");
        });
    }
    observeItemsCount() {
        const observerOption = {
            childList: true,
            subtree: true
        };
        const removeRow = document.querySelector('[data-tk-id="Remove"]');
        if (!removeRow) return;
        const onItemsCountChanged = this.calculateItemsCount.bind(this);
        const observer = new MutationObserver(onItemsCountChanged);
        observer.observe(removeRow, observerOption);
    }
    calculateItemsCount() {
        const removeRow = document.querySelector('[data-tk-id="Remove"]');
        const itemsCount = removeRow ? removeRow.querySelectorAll("tk-compare-button").length : 0;
        this.setAttribute("data-compare-items-count", itemsCount.toString());
    }
}







var $69165974676831f6$export$80844e5a810aad22;
(function(CompareState) {
    CompareState["ADDED"] = "a";
    CompareState["REMOVED"] = "p";
})($69165974676831f6$export$80844e5a810aad22 || ($69165974676831f6$export$80844e5a810aad22 = {}));
class $69165974676831f6$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.type = "Compare";
        this.button = this.querySelector("button") || undefined;
        this.item = this.getAttribute("data-tk-compare-item") || "";
        this.compareType = this.getAttribute("data-tk-compare-type") || "Art";
        this.asyncURL = this.getAttribute("data-tk-async-url") || (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        this.activeClass = this.getAttribute("data-tk-compare-active-class") || "tk-compare-button--active";
        this.itemList = document.querySelectorAll(`[data-tk-compare-item="${this.item}"]`);
        this.compareListLink = document.querySelector("tk-compare-list-link") || undefined;
        this.shouldRemoveAll = this.hasAttribute("data-tk-should-remove-all");
        this.wrapper = document.querySelector("tk-compare-wrapper") || undefined;
    }
    connectedCallback() {
        if (!this.button) throw new Error("Compare: Button is missing!");
        this.registerClickListener();
    }
    registerClickListener() {
        const handleCompare = this.shouldRemoveAll ? this.removeAllItems.bind(this) : this.addOrRemoveFromCompare.bind(this);
        this.pushListener({
            event: "click",
            element: this,
            action: handleCompare
        });
    }
    addOrRemoveFromCompare() {
        const data = {
            Id: this.item,
            Type: this.type,
            CompareType: this.compareType
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    async removeAllItems() {
        this.button.disabled = true;
        const itemList = document.querySelectorAll("[data-tk-compare-item]");
        const itemSet = new Set();
        itemList.forEach((item)=>{
            const id = item.getAttribute("data-tk-compare-item") || "";
            itemSet.add(id);
        });
        const promises = [];
        itemSet.forEach((id)=>{
            promises.push(this.fetch(id));
        });
        try {
            await Promise.all(promises);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).allRemoved.text);
            this.resetPage();
            this.updateItemsCount(true);
        } catch (error) {
            throw new Error(`${error}`);
        }
    }
    resetPage() {
        if (!this.wrapper) return;
        this.wrapper.innerHTML = "";
        const headerElement = document.querySelector("[data-tk-compare-header]");
        headerElement?.classList.add("tk-compare__header--empty");
        this.wrapper.insertAdjacentElement("beforeend", (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
                <div class="tk-message tk-message--fullwidth tk-message--padding-block-unset">
                    <span class="tk-message__label tk-message__label--fullwidth tk-message__label--text-center">
                        ${(0, $86b3c5b6d66bd808$export$ad480231e1cfb49).empty.text}
                    </span>
                </div>
            `));
        // remove remove all button
        const removeAllButton = document.querySelector("[data-tk-should-remove-all]");
        if (removeAllButton) removeAllButton.parentElement?.removeChild(removeAllButton);
    }
    fetch(id) {
        const data = {
            Id: id,
            Type: this.type,
            CompareType: this.compareType
        };
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.asyncURL,
                payload: data,
                resolveHandler: (success)=>resolve(success),
                showMessages: false
            });
        });
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        const json = response.dataAsJson;
        if (!json.success) return;
        const handler = {
            a: ()=>this.addActiveClass(),
            p: ()=>this.remove()
        };
        handler[json.comparestatus]();
        this.compareListLink?.updateCounter(response.dataAsJson.comparestatus);
    }
    showErrorMessage(error) {
        const errorMessage = this.getMessage(error);
        if (errorMessage !== "") (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, errorMessage);
    }
    // eslint-disable-next-line class-methods-use-this
    getMessage(error) {
        const tmpMessage = document.createElement("div");
        tmpMessage.innerHTML = error;
        const errorMessage = tmpMessage.querySelector("[data-tk-compare-failed-text]") || undefined;
        return errorMessage ? errorMessage.innerText : "";
    }
    addActiveClass() {
        this.itemList.forEach((item)=>{
            item.classList.add(this.activeClass);
        });
    }
    remove() {
        this.removeActiveClass();
        this.removeItem();
        // update items count
        this.updateItemsCount();
    }
    removeActiveClass() {
        this.itemList.forEach((item)=>{
            item.classList.remove(this.activeClass);
        });
    }
    removeItem() {
        const column = this.closest("[data-tk-column]");
        if (!column) return;
        const columnNumber = column.getAttribute("data-tk-column");
        const rows = document.querySelectorAll("[data-tk-row]");
        rows.forEach((row)=>{
            const col = row.querySelector(`[data-tk-column="${columnNumber}"]`);
            col?.remove();
        });
    }
    updateItemsCount(preventPageReset = false) {
        const itemsCountContainer = document.querySelector("[data-compare-items-count]");
        if (!itemsCountContainer) return;
        const itemsCountString = itemsCountContainer.getAttribute("data-compare-items-count");
        const itemsCount = itemsCountString ? parseInt(itemsCountString, 10) : 0;
        if (itemsCount <= 1 && !preventPageReset) this.resetPage();
    }
}





class $bfd0858a614fd0fd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector("select") || undefined;
        this.postURL = this.getAttribute("data-tk-compare-post-url") || window.location.href;
        this.targetDiv = this.getAttribute("data-tk-compare-target-div") || "[data-tk-compare-wrapper]";
        this.wrapper = document.querySelector("[data-tk-compare-wrapper]") || undefined;
    }
    connectedCallback() {
        if (!this.fieldElement || !this.wrapper) throw new Error("Compare: Elements are missing!");
        this.registerInputListener();
    }
    registerInputListener() {
        const onInput = this.fetch.bind(this);
        this.pushListener({
            event: "input",
            element: this.fieldElement,
            action: onInput
        });
    }
    fetch(event) {
        const target = event.currentTarget;
        const selectedItem = target.options.item(target.selectedIndex);
        if (!selectedItem) return;
        const data = {
            ArtCompareType: selectedItem.value,
            Target: this.targetDiv
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.postURL,
            resolveHandler: this.refreshContent.bind(this),
            payload: data
        });
    }
    refreshContent(response) {
        if (!response || !response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const targetWrapper = html.querySelector("[data-tk-compare-wrapper]");
        if (!targetWrapper) return;
        this.wrapper.innerHTML = targetWrapper.innerHTML;
    }
}




class $940f1243a5e55285$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: "tk-form-element",
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: "tk-manager",
                constructor: (0, $4576c900b5c49dcd$export$2e2bcd8739ae039)
            },
            {
                name: "tk-viewport",
                constructor: (0, $2e3d1137f4724c0f$export$2e2bcd8739ae039)
            },
            {
                name: "tk-tabs-accordion",
                constructor: (0, $59575c6d2ba9e740$export$2e2bcd8739ae039)
            },
            {
                name: "tk-table",
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: "tk-flag",
                constructor: (0, $0d07f57cc5d15afe$export$2e2bcd8739ae039)
            },
            {
                name: "tk-basket-button",
                constructor: (0, $127c03b03da38c7a$export$2e2bcd8739ae039)
            },
            {
                name: "tk-dialog",
                constructor: (0, $2215c02a950e9fbf$export$2e2bcd8739ae039)
            },
            {
                name: "tk-context-menu",
                constructor: (0, $d9484b764f1a944d$export$2e2bcd8739ae039)
            },
            {
                name: "tk-tooltip",
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: "tk-compare-content",
                constructor: (0, $4646e54a00c9195e$export$2e2bcd8739ae039)
            },
            {
                name: "tk-compare-wrapper",
                constructor: (0, $ff73fd6b4831733d$export$2e2bcd8739ae039)
            },
            {
                name: "tk-compare-button",
                constructor: (0, $69165974676831f6$export$2e2bcd8739ae039)
            },
            {
                name: "tk-compare-select",
                constructor: (0, $bfd0858a614fd0fd$export$2e2bcd8739ae039)
            }
        ]);
    }
}
// eslint-disable-next-line no-new
new $940f1243a5e55285$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=compare.js.map
